import { Injectable, Component, Input, ViewChild, Directive, ComponentFactoryResolver, Injector, ViewContainerRef, ElementRef, HostBinding, ContentChild, TemplateRef, NgModule } from '@angular/core';
import { TourService, ScrollingUtil, TourState, TourBackdropService, TourHotkeyListenerComponent, TourModule } from 'ngx-ui-tour-core';
import { MatMenu, MatMenuTrigger, MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { first } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/material/menu';
import * as ɵngcc2 from 'ngx-ui-tour-core';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@angular/material/card';
import * as ɵngcc5 from '@angular/material/button';
import * as ɵngcc6 from '@angular/material/icon';

function TourStepTemplateComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TourStepTemplateComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-card", 3);
    ɵngcc0.ɵɵlistener("click", function TourStepTemplateComponent_ng_template_2_Template_mat_card_click_0_listener($event) { return $event.stopPropagation(); });
    ɵngcc0.ɵɵelementStart(1, "mat-card-title");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "mat-card-content", 4);
    ɵngcc0.ɵɵelementStart(4, "mat-card-actions");
    ɵngcc0.ɵɵelementStart(5, "button", 5);
    ɵngcc0.ɵɵlistener("click", function TourStepTemplateComponent_ng_template_2_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.tourService.prev(); });
    ɵngcc0.ɵɵelementStart(6, "mat-icon");
    ɵngcc0.ɵɵtext(7, "chevron_left");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "button", 5);
    ɵngcc0.ɵɵlistener("click", function TourStepTemplateComponent_ng_template_2_Template_button_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.tourService.next(); });
    ɵngcc0.ɵɵelementStart(9, "mat-icon");
    ɵngcc0.ɵɵtext(10, "chevron_right");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "button", 6);
    ɵngcc0.ɵɵlistener("click", function TourStepTemplateComponent_ng_template_2_Template_button_click_11_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.tourService.end(); });
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r3 = ctx.step;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", step_r3 == null ? null : step_r3.title, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", step_r3 == null ? null : step_r3.content, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r2.tourService.hasPrev(step_r3));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r2.tourService.hasNext(step_r3));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", step_r3 == null ? null : step_r3.endBtnTitle, " ");
} }
const _c0 = function (a0) { return { step: a0 }; };
class NgxmTourService extends TourService {
}
NgxmTourService.ɵfac = /*@__PURE__*/ function () { let ɵNgxmTourService_BaseFactory; return function NgxmTourService_Factory(t) { return (ɵNgxmTourService_BaseFactory || (ɵNgxmTourService_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(NgxmTourService)))(t || NgxmTourService); }; }();
NgxmTourService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgxmTourService, factory: NgxmTourService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxmTourService, [{
        type: Injectable
    }], null, null); })();

class TourAnchorOpenerComponent {
    constructor() {
        this.menu = new MatMenu(undefined, undefined, {
            xPosition: 'after',
            yPosition: 'below',
            overlapTrigger: true,
            backdropClass: ''
        });
    }
}
TourAnchorOpenerComponent.ɵfac = function TourAnchorOpenerComponent_Factory(t) { return new (t || TourAnchorOpenerComponent)(); };
TourAnchorOpenerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TourAnchorOpenerComponent, selectors: [["tourAnchorOpener"]], viewQuery: function TourAnchorOpenerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(MatMenuTrigger, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.trigger = _t.first);
    } }, inputs: { menu: "menu" }, decls: 2, vars: 1, consts: [[3, "matMenuTriggerFor"], ["trigger", "matMenuTrigger"]], template: function TourAnchorOpenerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "span", 0, 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("matMenuTriggerFor", ctx.menu);
    } }, directives: [ɵngcc1.MatMenuTrigger], styles: ["[_nghost-%COMP%] {\n        display: none;\n      }"] });
TourAnchorOpenerComponent.propDecorators = {
    menu: [{ type: Input }],
    trigger: [{ type: ViewChild, args: [MatMenuTrigger,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TourAnchorOpenerComponent, [{
        type: Component,
        args: [{
                selector: 'tourAnchorOpener',
                template: `
    <span [matMenuTriggerFor]="menu" #trigger="matMenuTrigger"></span>
  `,
                styles: [`
      :host {
        display: none;
      }
    `]
            }]
    }], function () { return []; }, { menu: [{
            type: Input
        }], trigger: [{
            type: ViewChild,
            args: [MatMenuTrigger]
        }] }); })();

class TourStepTemplateService {
}
TourStepTemplateService.ɵfac = function TourStepTemplateService_Factory(t) { return new (t || TourStepTemplateService)(); };
TourStepTemplateService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: TourStepTemplateService, factory: TourStepTemplateService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TourStepTemplateService, [{
        type: Injectable
    }], null, null); })();

class TourAnchorMatMenuDirective {
    constructor(componentFactoryResolver, injector, viewContainer, element, tourService, tourStepTemplate, tourBackdrop) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.injector = injector;
        this.viewContainer = viewContainer;
        this.element = element;
        this.tourService = tourService;
        this.tourStepTemplate = tourStepTemplate;
        this.tourBackdrop = tourBackdrop;
        this.opener = this.viewContainer.createComponent(this.componentFactoryResolver.resolveComponentFactory(TourAnchorOpenerComponent)).instance;
    }
    ngOnInit() {
        this.tourService.register(this.tourAnchor, this);
    }
    ngOnDestroy() {
        this.tourService.unregister(this.tourAnchor);
    }
    // noinspection JSUnusedGlobalSymbols
    showTourStep(step) {
        var _a, _b;
        const htmlElement = this.element.nativeElement;
        this.isActive = true;
        this.tourStepTemplate.templateComponent.step = step;
        // Ignore step.placement
        if (!step.preventScrolling) {
            ScrollingUtil.ensureVisible(htmlElement);
        }
        this.opener.trigger._element = this.element;
        this.opener.trigger.menu = this.tourStepTemplate.templateComponent.tourStep;
        this.opener.trigger.menu.xPosition = ((_a = step.placement) === null || _a === void 0 ? void 0 : _a.xPosition) || 'after';
        this.opener.trigger.menu.yPosition = ((_b = step.placement) === null || _b === void 0 ? void 0 : _b.yPosition) || 'below';
        this.opener.trigger.ngAfterContentInit();
        this.opener.trigger.openMenu();
        if (step.enableBackdrop) {
            this.tourBackdrop.show(this.element);
        }
        else {
            this.tourBackdrop.close();
        }
        step.prevBtnTitle = step.prevBtnTitle || 'Prev';
        step.nextBtnTitle = step.nextBtnTitle || 'Next';
        step.endBtnTitle = step.endBtnTitle || 'End';
        if (this.menuCloseSubscription) {
            this.menuCloseSubscription.unsubscribe();
        }
        this.menuCloseSubscription = this.opener.trigger.menuClosed
            .pipe(first())
            .subscribe(() => {
            if (this.tourService.getStatus() !== TourState.OFF) {
                this.tourService.end();
            }
            this.tourBackdrop.close();
        });
    }
    hideTourStep() {
        this.isActive = false;
        if (this.menuCloseSubscription) {
            this.menuCloseSubscription.unsubscribe();
        }
        this.opener.trigger.closeMenu();
        if (this.tourService.getStatus() === TourState.OFF) {
            this.tourBackdrop.close();
        }
    }
}
TourAnchorMatMenuDirective.ɵfac = function TourAnchorMatMenuDirective_Factory(t) { return new (t || TourAnchorMatMenuDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(NgxmTourService), ɵngcc0.ɵɵdirectiveInject(TourStepTemplateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.TourBackdropService)); };
TourAnchorMatMenuDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TourAnchorMatMenuDirective, selectors: [["", "tourAnchor", ""]], hostVars: 2, hostBindings: function TourAnchorMatMenuDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("touranchor--is-active", ctx.isActive);
    } }, inputs: { tourAnchor: "tourAnchor" } });
TourAnchorMatMenuDirective.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: Injector },
    { type: ViewContainerRef },
    { type: ElementRef },
    { type: NgxmTourService },
    { type: TourStepTemplateService },
    { type: TourBackdropService }
];
TourAnchorMatMenuDirective.propDecorators = {
    tourAnchor: [{ type: Input }],
    isActive: [{ type: HostBinding, args: ['class.touranchor--is-active',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TourAnchorMatMenuDirective, [{
        type: Directive,
        args: [{
                selector: '[tourAnchor]'
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.Injector }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ElementRef }, { type: NgxmTourService }, { type: TourStepTemplateService }, { type: ɵngcc2.TourBackdropService }]; }, { isActive: [{
            type: HostBinding,
            args: ['class.touranchor--is-active']
        }], tourAnchor: [{
            type: Input
        }] }); })();

class TourStepTemplateComponent extends TourHotkeyListenerComponent {
    constructor(tourStepTemplateService, tourService) {
        super(tourService);
        this.tourStepTemplateService = tourStepTemplateService;
        this.tourService = tourService;
        this.step = {};
    }
    ngAfterViewInit() {
        this.tourStepTemplateService.templateComponent = this;
    }
}
TourStepTemplateComponent.ɵfac = function TourStepTemplateComponent_Factory(t) { return new (t || TourStepTemplateComponent)(ɵngcc0.ɵɵdirectiveInject(TourStepTemplateService), ɵngcc0.ɵɵdirectiveInject(NgxmTourService)); };
TourStepTemplateComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TourStepTemplateComponent, selectors: [["tour-step-template"]], contentQueries: function TourStepTemplateComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TemplateRef, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.stepTemplateContent = _t.first);
    } }, viewQuery: function TourStepTemplateComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(MatMenu, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tourStep = _t.first);
    } }, inputs: { stepTemplate: "stepTemplate" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 5, consts: [[1, "tour-step", 3, "overlapTrigger"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["defaultTemplate", ""], [3, "click"], [3, "innerHTML"], ["mat-icon-button", "", 3, "disabled", "click"], ["mat-button", "", 3, "click"]], template: function TourStepTemplateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-menu", 0);
        ɵngcc0.ɵɵtemplate(1, TourStepTemplateComponent_ng_container_1_Template, 1, 0, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, TourStepTemplateComponent_ng_template_2_Template, 13, 5, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵproperty("overlapTrigger", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.stepTemplate || ctx.stepTemplateContent || _r1)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(3, _c0, ctx.step));
    } }, directives: [ɵngcc1.MatMenu, ɵngcc3.NgTemplateOutlet, ɵngcc4.MatCard, ɵngcc4.MatCardTitle, ɵngcc4.MatCardContent, ɵngcc4.MatCardActions, ɵngcc5.MatButton, ɵngcc6.MatIcon], styles: [".tour-step .mat-menu-content {\n        padding: 0 !important;\n      }"] });
TourStepTemplateComponent.ctorParameters = () => [
    { type: TourStepTemplateService },
    { type: NgxmTourService }
];
TourStepTemplateComponent.propDecorators = {
    tourStep: [{ type: ViewChild, args: [MatMenu,] }],
    stepTemplate: [{ type: Input }],
    stepTemplateContent: [{ type: ContentChild, args: [TemplateRef,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TourStepTemplateComponent, [{
        type: Component,
        args: [{
                selector: 'tour-step-template',
                template: `
    <mat-menu [overlapTrigger]="false" class="tour-step">
      <ng-container
        *ngTemplateOutlet="
          stepTemplate || stepTemplateContent || defaultTemplate;
          context: { step: step }
        "
      ></ng-container>
    </mat-menu>
    <ng-template #defaultTemplate let-step="step">
      <mat-card (click)="$event.stopPropagation()">
        <mat-card-title>
          {{ step?.title }}
        </mat-card-title>
        <mat-card-content [innerHTML]="step?.content">
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-icon-button
            [disabled]="!tourService.hasPrev(step)"
            (click)="tourService.prev()"
          >
            <mat-icon>chevron_left</mat-icon>
          </button>
          <button
            mat-icon-button
            [disabled]="!tourService.hasNext(step)"
            (click)="tourService.next()"
          >
            <mat-icon>chevron_right</mat-icon>
          </button>
          <button mat-button (click)="tourService.end()">
            {{ step?.endBtnTitle }}
          </button>
        </mat-card-actions>
      </mat-card>
    </ng-template>
  `,
                styles: [`
      ::ng-deep .tour-step .mat-menu-content {
        padding: 0 !important;
      }
    `]
            }]
    }], function () { return [{ type: TourStepTemplateService }, { type: NgxmTourService }]; }, { tourStep: [{
            type: ViewChild,
            args: [MatMenu]
        }], stepTemplate: [{
            type: Input
        }], stepTemplateContent: [{
            type: ContentChild,
            args: [TemplateRef]
        }] }); })();

class TourMatMenuModule {
    static forRoot() {
        return {
            ngModule: TourMatMenuModule,
            providers: [
                TourStepTemplateService,
                TourBackdropService,
                TourService,
                NgxmTourService
            ]
        };
    }
}
TourMatMenuModule.ɵfac = function TourMatMenuModule_Factory(t) { return new (t || TourMatMenuModule)(); };
TourMatMenuModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TourMatMenuModule });
TourMatMenuModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, TourModule,
            MatMenuModule, MatCardModule, MatButtonModule, MatIconModule,
        ], TourModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TourMatMenuModule, [{
        type: NgModule,
        args: [{
                declarations: [TourAnchorMatMenuDirective, TourStepTemplateComponent, TourAnchorOpenerComponent],
                entryComponents: [TourAnchorOpenerComponent],
                exports: [TourAnchorMatMenuDirective, TourStepTemplateComponent, TourModule],
                imports: [CommonModule, TourModule,
                    MatMenuModule, MatCardModule, MatButtonModule, MatIconModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TourMatMenuModule, { declarations: function () { return [TourAnchorMatMenuDirective, TourStepTemplateComponent, TourAnchorOpenerComponent]; }, imports: function () { return [CommonModule, TourModule,
        MatMenuModule, MatCardModule, MatButtonModule, MatIconModule]; }, exports: function () { return [TourAnchorMatMenuDirective, TourStepTemplateComponent, TourModule]; } }); })();

/*
 * Public API Surface of ngx-ui-tour-md-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TourAnchorMatMenuDirective, TourMatMenuModule, NgxmTourService as TourService, TourStepTemplateComponent, NgxmTourService as ɵa, TourStepTemplateService as ɵb, TourAnchorOpenerComponent as ɵc };

